<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Objednávky - seznam</strong>
      </div>
      <action-tools :router-options="routerOptions" :handle-refresh="handleRefresh"></action-tools>
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-6">
          <a-dropdown :placement="'bottomLeft'">
            <a-button>Hromadné akce
              <a-icon type="down"/>
            </a-button>
            <a-menu slot="overlay">
              <a-menu-item @click="showModalStatus(status)" :key="'st' + status.text" v-for="status in statuses" :disabled="selectedRowKeys.length === 0" :class="{'disabled': selectedRowKeys.length === 0}">
                {{ status.text | capitalize({ onlyFirstLetter: true }) }}
              </a-menu-item>
              <a-menu-divider></a-menu-divider>
              <a-menu-item :disabled="selectedRowKeys.length === 0" :class="{'disabled': selectedRowKeys.length === 0}">
                <a-popconfirm @confirm="confirmDelete(selectedRowKeys)" okText="Potvrdit" cancelText="Zrušit">
                  <template slot="title">
                    <p>Opravdu si přejete odstranit tyto položky?</p>
                    <div v-if="selectedRowKeys.length > 0">
                      {{ selectedRowKeys }}
                    </div>
                  </template>
                  Odstranit
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
        <div class="text-right col-md-6">
          <a-input-search
            placeholder="Hledat..."
            style="width: 200px"
            @search="handleSearch"
          />
        </div>
      </div>
      <a-table
        tableLayout="auto"
        :rowSelection="rowSelection"
        :rowKey="record => record.odr_id"
        :columns="columns"
        :loading="loading"
        :dataSource="orders"
        class="utils__scrollTable"
        :scroll="{ x: '100%' }"
      >
        <router-link
          slot="odr_id"
          slot-scope="value"
          class="utils__link--underlined"
          :to="'/ecommerce/order/detail/' + value"
        >#<span v-if="searchText">
            <template
              v-for="(fragment, i) in value.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{value}}</template>
        </router-link>
        <span slot="status" slot-scope="text">
          <a-tag :color="statuses.find(x => x.status === text).color">
            <span v-if="searchText">
              <template
                v-for="(fragment, i) in statuses.find(x => x.status === text).text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                >{{fragment}}</mark>
                <template v-else>{{fragment}}</template>
              </template>
            </span>
            <template v-else>{{ statuses.find(x => x.status === text).text }}</template>
          </a-tag>
        </span>
        <span slot="note" slot-scope="text">
          <a-button v-if="text !== null" @click="showNote(text)">Zobrazit</a-button>
          <a-alert type="info" message="Není" v-else :showIcon="true"></a-alert>
        </span>
        <template slot="customRender" slot-scope="text">
          <span v-if="searchText">
            <template
              v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{text}}</template>
        </template>
        <template slot="price" slot-scope="text">
          <span v-if="searchText">
            <template
              v-for="(fragment, i) in text === null ? '0,00' : text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template> Kč
          </span>
          <template v-else>{{ text === null ? 0 : text | currency }}</template>
        </template>
        <span
          slot="active"
          slot-scope="value"
          :class="[value === undefined ? '' : value ? 'font-size-12 badge badge-success' : 'font-size-12 badge badge-danger']"
        >
          <span v-if="searchText">
            <template v-for="(fragment, i) in (value ? 'ano' : 'ne').toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))" >
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{value ? 'ano' : 'ne'}}</template>
        </span>
        <span
          slot="dates"
          slot-scope="text"
        >
          <span v-if="searchText">
            <template v-for="(fragment, i) in toLocaleDate(text).toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))" >
              <mark
                v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                :key="i"
                class="highlight"
              >{{fragment}}</mark>
              <template v-else>{{fragment}}</template>
            </template>
          </span>
          <template v-else>{{toLocaleDate(text)}}</template>
        </span>
        <span slot="action" slot-scope="record">
          <router-link :to="'/ecommerce/order/detail/'+record.odr_id">
            <a-button icon="search" size="small" class="mr-1">Zobrazit</a-button>
          </router-link>
          <a-popconfirm @confirm="confirmDelete([record.odr_id])" okText="Potvrdit" cancelText="Zrušit" v-if="!record.is_deleted">
            <template slot="title">
              <p>Opravdu si přejete odstranit položku: #{{ record.odr_id }} ?</p>
            </template>
            <a-button icon="delete" size="small">Odstranit</a-button>
          </a-popconfirm>
        </span>
        <template slot="footer">
          {{ orders.length }} položek
        </template>
      </a-table>
    </div>
    <a-modal v-model="isModalStatusVisible" :confirmLoading="loading" v-if="selectedStatus !== null">
      <p>Opravdu si přejete upravit status na <strong>{{ selectedStatus.text }}</strong> pro tyto položky?</p>
      <div v-if="selectedRowKeys.length > 0">
        {{ selectedRowKeys }}
      </div>.
      <template slot="footer">
        <a-button key="back" @click="cancelModalStatus">Zrušit</a-button>
        <a-button type="dashed" :loading="loading" @click="confirmEmail(selectedRowKeys, selectedStatus.status, false)">
          Jen změnit
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="confirmEmail(selectedRowKeys, selectedStatus.status, true)">
          Informovat o změně e-mailem
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import ActionTools from '@/components/MyComponents/ActionTools'

export default {
  components: { ActionTools },
  data: function () {
    return {
      selectedStatus: null,
      isModalStatusVisible: false,
      image: {
        errors: [],
      },
      searchText: '',
      loading: false,
      selectedRowKeys: [],
      routerOptions: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'odr_id',
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.odr_id - b.odr_id,
          scopedSlots: {
            customRender: 'odr_id',
          },
        },
        {
          title: 'Vytvořeno',
          dataIndex: 'created_at',
          sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
          scopedSlots: {
            customRender: 'dates',
          },
        },
        {
          title: 'Zákazník',
          dataIndex: 'customer',
          sorter: (a, b) => {
            return a.customer.localeCompare(b.customer)
          },
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'Firma',
          dataIndex: 'is_company',
          sorter: (a, b) => a.is_company - b.is_company,
          scopedSlots: {
            customRender: 'active',
          },
        },
        {
          title: 'Stav',
          dataIndex: 'status',
          sorter: (a, b) => a.status.localeCompare(b.status),
          scopedSlots: {
            customRender: 'status',
          },
        },
        {
          title: 'Poznámka',
          dataIndex: 'note',
          sorter: (a, b) => (a.note === null) - (b.note === null),
          scopedSlots: {
            customRender: 'note',
          },
        },
        {
          title: 'Platba',
          dataIndex: 'phe_name',
          sorter: (a, b) => {
            return a.phe_name.localeCompare(b.phe_name)
          },
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'Telefon',
          dataIndex: 'ahe_telephone_number',
          sorter: (a, b) => {
            return a.ahe_telephone_number.localeCompare(b.ahe_telephone_number)
          },
          scopedSlots: {
            customRender: 'customRender',
          },
        },
        {
          title: 'Cena',
          dataIndex: 'order_total_vat',
          sorter: (a, b) => {
            return a.order_total_vat - b.order_total_vat
          },
          scopedSlots: {
            customRender: 'price',
          },
        },
        {
          title: 'Akce',
          key: 'action',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
    }
  },
  computed: {
    orders: function () {
      return this.$store.getters['order/filterItems'](this.searchText)
    },
    statuses: function () {
      return this.$store.getters['order/getStatuses']
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        selections: [{
          key: 'all-data',
          text: 'Vybrat všechny položky',
          onSelect: () => {
            this.selectedRowKeys = this.selectedRowKeys.length === 0 ? this.orders.map(item => item.odr_id) : []
          },
        }],
        onSelection: this.onSelection,
      }
    },
  },
  methods: {
    cancelModalStatus() {
      this.isModalStatusVisible = false
    },
    showModalStatus(status) {
      this.isModalStatusVisible = true
      this.selectedStatus = status
    },
    confirmEmail(items, status, sent) {
      this.loading = true
      this.$store.dispatch('order/status', { status: status, sent: sent, items: items })
        .then(() => {
          if (this.selectedRowKeys.length > 0) {
            this.selectedRowKeys = items.filter(x => !this.selectedRowKeys.includes(x))
              .concat(this.selectedRowKeys.filter(x => !items.includes(x)))
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isModalStatusVisible = false
          this.loading = false
        })
    },
    showNote(text) {
      const h = this.$createElement
      this.$modal.info({
        title: 'Poznámka zákazníka',
        content: h('div', {}, [
          h('p', text),
        ]),
        closable: true,
        onOk() {},
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    toLocaleDate: function (text) {
      return this.$options.filters.formatDate(text)
    },
    handleRefresh() {
      this.loading = true
      this.$store.dispatch('order/getList')
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    confirmDelete(orders) {
      this.loading = true
      this.$store.dispatch('order/delete', orders)
        .then(() => {
          if (this.selectedRowKeys.length > 0) {
            this.selectedRowKeys = orders.filter(x => !this.selectedRowKeys.includes(x))
              .concat(this.selectedRowKeys.filter(x => !orders.includes(x)))
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch(searchText) {
      this.searchText = searchText
    },
  },
  created() {
    this.handleRefresh()
  },
}
</script>

<style lang="scss" module scoped>
  @import "./style.module.scss";
</style>
